import { Button } from "@/components/ui/Button";
import { clsx } from "clsx";
import React from "react";

export const CongratsActionButton = ({
  children,
  onClick,
  className,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <Button
      className={clsx("h-[60px] w-[200px] rounded-full px-8 py-2", className)}
      onClick={onClick}
    >
      <span className="flex items-center justify-center gap-2 text-base font-normal">
        {children}
      </span>
    </Button>
  );
};
